<template>
  <div>
    <b-button v-b-modal.modalConfiguracoesUsuario variant="primary">Settings</b-button>
    <b-modal
      id="modalConfiguracoesUsuario"
      ref="modalConfiguracoesUsuario"
      title="Settings"
      hide-footer
      size="lg"
    >
      <b-list-group>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          <span class="w-50">Notification tone</span>
          <b-input-group class="w-50">
            <b-input-group-text slot="append" class="icone-play" @click="tocarSomNotificacao()">
              <strong class="text-success">
                <font-awesome-icon icon="play" />
              </strong>
            </b-input-group-text>
            <b-select
              v-model="somNotificacao"
              :options="opicoesSonsNotificacoes"
              @change="somNotificacaoSelecionado"
              size="lg"
            ></b-select>
          </b-input-group>
        </b-list-group-item>
      </b-list-group>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import audioUtil from '../../../utils/audioUtil';
import { CHAVE_SOM_NOVA_MENSAGEM } from '../../../utils/configuracoesUsuarioUtil';

export default {
  data() {
    return {
      show: true,
      loading: false,
      somNotificacao: undefined,
      opicoesSonsNotificacoes: [
        {
          value: 0,
          text: 'No sound',
        },
        {
          value: 1,
          text: 'Tone 1',
        },
        {
          value: 2,
          text: 'Tone 2',
        },
        {
          value: 3,
          text: 'Tone 3',
        },
        {
          value: 4,
          text: 'Tone 4',
        },
      ],
    };
  },
  async created() {

    await this.listarConfiguracoesUsuarioLogado();
    const configuracaoSomNotificacao = this.configuracoes.find(
      (c) => c.chave == CHAVE_SOM_NOVA_MENSAGEM,
    );
    if (configuracaoSomNotificacao) {
      this.somNotificacao = configuracaoSomNotificacao.valor;
    }
  },
  computed: {
    ...mapGetters(['usuarioLogado', 'configuracoes']),
  },
  methods: {
    ...mapActions([
      'salvarConfiguracaoUsuario',
      'listarConfiguracoesUsuarioLogado',
    ]),
    async somNotificacaoSelecionado() {
      const configuracao = {
        chave: CHAVE_SOM_NOVA_MENSAGEM,
        valor: this.somNotificacao,
      };
      await this.salvarConfiguracaoUsuario(configuracao);
    },
    tocarSomNotificacao() {
      audioUtil.tocarAudioNovaMensagemChat(this.somNotificacao);
    },
  },
};
</script>

<style scoped>
.icone-play {
  cursor: pointer;
}
</style>
